/**
 * TypeORM Shim for Browser Environments
 *
 * This file provides no-op implementations of TypeORM decorators for use in web applications.
 * When bundling for the browser, Vite can be configured to alias 'typeorm' to this file,
 * allowing entity classes to be imported without triggering TypeORM's server-side logic.
 *
 * The decorators do nothing in the browser - they just return the target unchanged.
 * This allows the entity classes to be used as plain TypeScript interfaces/types.
 *
 * IMPORTANT: All decorator functions accept any arguments but ignore them completely.
 * This ensures that decorator metadata (like database column names) is not included in the bundle.
 */

function noop(..._args: Array<any>): PropertyDecorator {
  return () => {
    // No-op - arguments are discarded
  };
}

function classNoop(..._args: Array<any>): ClassDecorator {
  return (target) => target;
}

export const Entity = classNoop;
export const Column = noop;
export const PrimaryColumn = noop;
export const PrimaryGeneratedColumn = noop;
export const CreateDateColumn = noop;
export const UpdateDateColumn = noop;
export const DeleteDateColumn = noop;
export const VersionColumn = noop;
export const ObjectIdColumn = noop;
export const ManyToOne = noop;
export const OneToMany = noop;
export const OneToOne = noop;
export const ManyToMany = noop;
export const JoinColumn = noop;
export const JoinTable = noop;
export const Index = noop;
export const Unique = noop;
export const Check = noop;
export const Exclusion = noop;
export const Generated = noop;
export const EntityRepository = noop;
export const Transaction = noop;
export const TransactionManager = noop;
export const TransactionRepository = noop;
export const TreeChildren = noop;
export const TreeParent = noop;
export const TreeLevelColumn = noop;
export const ViewColumn = noop;
export const ViewEntity = classNoop;
export const ChildEntity = classNoop;
export const TableInheritance = noop;
export const EventSubscriber = classNoop;
export const AfterInsert = noop;
export const AfterLoad = noop;
export const AfterRemove = noop;
export const AfterUpdate = noop;
export const BeforeInsert = noop;
export const BeforeRemove = noop;
export const BeforeUpdate = noop;
export const RelationId = noop;
